import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28383510"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "pagination justify-content-center pagination_style1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-link" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "linearicons-arrow-left" })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-link" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "linearicons-arrow-right" })
], -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_ctx.showPrevious())
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              class: "page-item",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.paginationPreviousClick()))
            }, _hoisted_5))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagination.items, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.value
          }, [
            (_ctx.showPaginationItem(index) &&
              _ctx.pagination.items.length > 1)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: _normalizeClass(['page-item', {'active':index == _ctx.activeItemInternal}]),
                  onClick: ($event: any) => (_ctx.paginationItemClick(index))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(['page-link', {'active-link':index == _ctx.activeItemInternal}])
                  }, _toDisplayString(item.name), 3)
                ], 10, _hoisted_6))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        (_ctx.showNext())
          ? (_openBlock(), _createElementBlock("li", {
              key: 1,
              class: "page-item",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.paginationNextClick()))
            }, _hoisted_8))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}